import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from "@material-ui/core";
import { COLORS } from '../Theme'

import React, { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import '../css/modal.css';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';

import axios from 'axios';
import { headadmin as v_headadmin, basic, Values, SNACKBAR_TIME } from '../../request/values';


const useStyles = makeStyles((theme) => ({

    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    content: {
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '230px 1fr',
    },
    sidebar: {
        display: 'grid',
        gridTemplateRows: '60px 80px 100px 100px 100px 1fr',
        backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
    },
    mainPage: {
        display: 'grid',
        gridTemplateRows: '60px 1fr',
    },
    title: {
        margin: 'auto 0px auto 35px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: `${COLORS.WHITE}`,
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        border: 'solid white',
        cursor: 'pointer',
        borderWidth: '0px 0px 1px 0px',
        "& img": {
            width: 'auto',
            maxHeight: '50%',
            margin: '10px',
        },
        "& #name": {
            display: 'inline-block',
            margin: 'auto 0px auto 0px',
            fontFamily: 'NanumR',
            fontSize: '1.5rem',
            fontWeight: 'bolder',
        },
    },
    userinfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& #name": {
            display: 'inline-block',
            fontFamily: 'NanumR',
            fontSize: '1.25rem',
            fontWeight: 'bolder',
        },
    },
    menu: {
        border: 'solid white',
        borderWidth: '0px 0px 1px 0px',
        "& ul": {
            marginTop: '10px',
            "& li": {
                fontSize: '1rem',
                fontWeight: 'bolder',
                color: `${COLORS.SLATE_GREY}`,
                "& ul": {
                    listStyle: 'none',
                    paddingLeft: '0px',
                    "& li": {
                        fontSize: '1rem',
                        fontWeight: 'normal',
                        margin: '0px',
                        cursor: 'pointer',
                    }
                }
            }
        }

    },
    navigator: {
        display: 'grid',
        gridTemplateColumns: '3fr 2fr',
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
    form: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        gap: '5%',
        "& input": {
            width: '70%',
            height: '55%',
        },
        "& Button": {
            border: 'solid 1px',
        }
    },
    classList: {
        "& #addLicense": {
            padding: '5px 25px',
            margin: '1.5vh 0',
            color: `${COLORS.WHITE}`,
            borderRadius: '10px',
            backgroundColor: `${COLORS.WATER_BLUE}`,
        },
    },
    table: {
        display: 'grid',
        gridTemplateRows: '1fr 7fr 1fr',
        width: '95%',
        height: '60vh',
        margin: '1% auto',  
        border: 'solid 2px',
        borderRadius: '10px',
        backgroundColor: `${COLORS.WHITE}`,
    },
    tableTitle: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 15px',
        border: 'solid lightgray',
        borderWidth: '0 0 2px 0',
    },
    titleName: {
        fontSize: '1rem',
        fontWeight: 'bold',
        color: `${COLORS.SLATE_GREY}`, 
    },
    tableInfo: {
        display: 'grid',
        gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 10px',   
        "& input": {
            borderColor: 'black',
            borderRadius: '10px',
            maxHeight: '50px',
        },
        "& select": {
            padding: '5px',
            fontFamily:'Nanumgothic',
            appearance : 'none',
        },
    },
    infoContainer: {
        padding: '5px 30px',
        display: 'grid',
        gridTemplateRows: '30px 1fr',
    },
    buttonContainer:{
        display: 'grid',
        gridTemplateColumns: '1fr 15vw 3vw',
    },
    checkInput: {
        borderColor: 'black',
        borderRadius: '10px',
        maxHeight: '50px',
    },
    nonInput: {
        background: 'lightgray',
        color: 'gray',
        borderColor: 'black',
        borderRadius: '10px',
        maxHeight: '50px',
    },
    checkBtn: {
        width: '10vw',
        borderRadius: '10px',
        margin: '0 auto',
        color: `${COLORS.WHITE}`,
        backgroundColor: `${COLORS.PUMPKIN}`
    },
    nonBtn: {
        width: '10vw',
        borderRadius: '10px',
        margin: '0 auto',
        color: `${COLORS.WHITE}`,
        backgroundColor: `${COLORS.LIGHT_GREY}`
    },
}));

const SERVER = basic.server


export interface propsType {
    searchKeyword: string
}

const HeadAdminAddLicense: React.FC<any> = (props) => {

    const classes = useStyles();

    const { member } = props;
    const [licenseName, setLicenseName] = useState<any | null>();
    const [licenseImage, setLicenseImage ] = useState<any | null>();
    const [licenseMenualFile, setLicenseMenualFile ] = useState<any | null>();
    const [licenseDevelopTime, setLicenseDevelopTime ] = useState<any | null>();
    const [licenseLevel, setLicenseLevel] = useState<any | null>();
    const [licensePrice, setLicensePrice] = useState<any | null>();
    const [productSalePrice, setproductSalePrice] = useState<any | null>();
    const [auth, setAuth] = useState<boolean>(false);
    const [codevalidate, setflags] = useState<boolean>(true);
    
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const history = useHistory();


    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
    
        if (id == 'licenseName') setLicenseName(value);
        else if (id == 'licenseImage') setLicenseImage(value);
        else if (id == 'licenseMenualFile') setLicenseMenualFile(value);
        else if (id == 'licenseLevel') setLicenseLevel(value);
        else if (id == 'licenseDevelopTime') setLicenseDevelopTime(value);
        else if (id == 'productSalePrice') setproductSalePrice(value);
        else if (id == 'licensePrice') setLicensePrice(value);
        
    }
    const handleButton = (e: any) => {
        if (auth) {
          enqueueSnackbar(ToastStr.LICENSE_AUTH_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME })
          setflags(false)
          document.getElementById("licenseName")?.setAttribute("readonly", "readonly");
        } else {
            // setAnimation(true);
            if (licenseName == null)
                enqueueSnackbar(ToastStr.LICENSE_NAME_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
            else
                licenseNameCheck();
        }
    }

    const nothing = () =>{
    }

    const licenseNameCheck = () => {
        setAuth((prevState) => true);
        let url = new URL(SERVER + v_headadmin.headadmin + v_headadmin.auth_license_info);
        let params = { 'licenseName': licenseName ? licenseName.toString().trim() : '', 'action': 'join' }
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        }).then((res) => {
            return res.data
        }).then((data: any) => {
            console.log(data);
            if (data.code == Values.SUCCESS_CODE) {
                enqueueSnackbar(ToastStr.LICENSE_NAME_DUPLICATION, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                setAuth((prevState) => false);
            } else if (data.code == Values.FAIL_CODE) {
                // this is success == dont exist same id
                enqueueSnackbar(ToastStr.LICENSE_AUTH_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME * 2 })
                setAuth((prevState) => true);
                setflags(false);
                document.getElementById("licenseName")?.setAttribute("readonly", "readonly");
            }
        })
    }
    
    const licenseAdd = (event: any) => {
        if(!auth)
            enqueueSnackbar(ToastStr.CHECK_VALIDATE_CODE_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
        else{
            axios({
                method: "POST",
                data: {
                    licenseName: licenseName,
                    licenseLicenseLevel: licenseLevel,
                    licensePrice: licensePrice,
                    licenseImage: licenseImage,
                    licenseMenualFile: licenseMenualFile,
                    licenseDevelopTime: licenseDevelopTime,
                    productSalePrice: productSalePrice,
                    //email: member.id,
                    //email: "admin@mittelstand.co.kr",
                },
                withCredentials: true,
                url: SERVER + v_headadmin.headadmin + v_headadmin.license_add,
            }).then((res) => {
                return res.data
            }).then((data: any) => {
                console.log(data)
                console.log(data.code)
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.LICENSE_CREATE_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME })
                    history.push({
                        pathname: '/headadminLicenselist',
                    });
                } else {
                    if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.LICENSE_CREATE_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME })
                    }
                }
            })
        }
    }

    const moveMaterialList = () => {
        history.push('/headAdminMaterialList')
    }
    const moveLicenseList = () => {
        history.push('/headAdminLicenseList')
    }
    const moveClassList = () => {
        history.push('/headAdminClassList')
    }
    const moveClassManage = () => {
        history.push('/headAdminClassManage')
    }
    const moveMemberList = () => {
        history.push('/headAdminMemberList')
    }
    const moveAccountManage = () => {
        history.push('/headAdminAccountManage')
    }

    return (
        <div className={classes.background}>
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.sidebar}>
                    <div className={classes.logo} onClick={(e) => moveClassList()}>
                        <img src="/images/p.webp"></img>
                        <Typography id="name">플레이스타트업</Typography>
                    </div>
                    <div className={classes.userinfo}>
                        <Typography id="name">{member.name}님, 환영합니다!</Typography>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                품목 관리
                                <ul>
                                    <li onClick={(e) => moveMaterialList()}>재료 목록</li>
                                    <li onClick={(e) => moveLicenseList()}>제품 목록</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                교육 관리
                                <ul>
                                    <li onClick={(e) => moveClassList()}>교육 목록</li>
                                    <li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className={classes.menu}>
                        <ul>
                            <li>
                                회원 관리
                                <ul>
                                    <li onClick={(e) => moveMemberList()}>회원 목록</li>
                                    <li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={classes.mainPage}>
                    <div className={classes.navigator}>
                        <div className={classes.title}>재료 추가</div>
                        <div className={classes.form}>
                        </div>
                    </div>
                    <div className={classes.classList}>
                        <div className={classes.table}>
                            <div className={classes.tableTitle}>
                                <Typography className={classes.titleName}>재료 정보 입력</Typography>
                            </div>
                            <div className={classes.tableInfo}>
                                <div className={classes.infoContainer}>
                                    <Typography>제품명</Typography>
                                    <div id="codeContainer">
                                        <input type="text" id="licenseName" className={codevalidate? classes.checkInput : classes.nonInput} onChange={valueChangeHandler}></input>
                                        <Button id="codeValidate" className={codevalidate? classes.checkBtn : classes.nonBtn} onClick={codevalidate ? handleButton : nothing}>
                                            <Typography>
                                                코드 중복 체크
                                            </Typography>
                                        </Button>
                                    </div>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>제품 레벨</Typography>
                                    <input type="text" id="licenseLevel" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>개발 시간(초)</Typography>
                                    <input type="text" id="licenseDetail" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>제품 가격</Typography>
                                    <input type="text" id="licensePrice" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>제품 판매 가격</Typography>
                                    <input type="text" id="productSalePrice" onChange={valueChangeHandler}></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>제품 사진</Typography>
                                    <input type="text" id="licenseImage"></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>제품 메뉴얼 파일</Typography>
                                    <input type="text" id="licenseMenualFile" onChange={valueChangeHandler}></input>
                                </div>
                            </div>
                            <div className={classes.buttonContainer}>
                                <div></div>
                                <Button id="addLicense" onClick={licenseAdd}>
                                    <Typography>
                                        재료 추가하기
                                    </Typography>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default HeadAdminAddLicense;